import ApiConstants from "../constants/ApiConstants";
import Utility from "../utility/Utility";
import http from "../http";
import moment from "moment";
import { FILE_TYPE } from "../constants/Constant";
import axios from "axios";

export interface AttendanceAPIConfig {
  // SearchTerm?: string;
  Limit?: number;
  query?: string;
  sort?: string;
  page?: string;
  sortDir?: string;
  CurrentPage?: number;
  Order?: string;
  Field?: string;
}
export interface TeamAttendanceAPIConfig {
  filter?: string;
  Limit?: number;
  query?: string;
  sort?: string;
  page?: string;
  sortDir?: string;
  CurrentPage?: number;
  Order?: string;
  Field?: string;
  searchField?: string;
  searchString?: string;
  shift?: string;
  userType?: string;
  search?: string;
  status?: string;
}

export interface dashboardTeamAttendanceAPIConfig {
  filter?: string;
  limit?: number;
  query?: string;
  sort?: string;
  page?: string;
  sortDir?: string;
  CurrentPage?: number;
  Order?: string;
  field?: string;
  searchField?: string;
  searchString?: string;
  shift?: string;
  userType?: string;
  search?: string;
  status?: string;
}

const defaultConfig: AttendanceAPIConfig = {
  Limit: 20,
  page: "0",
  sort: "clockIn",
  sortDir: "desc",
  query: `clockIn>${moment(moment().format())
    .startOf("month")
    .format("YYYY-MM-DD 00:00")},clockIn<${moment(moment().format())
    .endOf("month")
    .format("YYYY-MM-DD 23:59")}`,
};

export const defaultTeamConfig: TeamAttendanceAPIConfig = {
  Limit: 20,
  page: "0",
  sort: "createdOn",
  sortDir: "desc",
  filter: "",
  query: `clockIn>${moment().format(
    "YYYY-MM-DD 00:00"
  )},clockIn<${moment().format("YYYY-MM-DD 23:59")}`,
  searchField: "",
  searchString: "",
  userType: "all",
  shift: "",
  search: ""
};

export const defaultDashboardTeamConfig: dashboardTeamAttendanceAPIConfig = {
  limit: 5,
  page: "0",
  sort: "createdOn",
  sortDir: "desc",
  filter: "",
  query: `clockIn=${moment().format(
    "YYYY-MM-DD "+moment().format("HH:mm")
  )}`,
  searchField: "",
  searchString: "",
  userType: "all",
  shift: "",
  search: "",
  status:""
};

class AttendanceService {
  static apiConfig: AttendanceAPIConfig;
  static apiTeamConfig: TeamAttendanceAPIConfig;
  static apiDashboardTeamConfig: dashboardTeamAttendanceAPIConfig;
  static getAttendanceByPage() {
    if (Utility.isEmpty(this.apiConfig)) {
      this.apiConfig = defaultConfig;
    }
    const url = ApiConstants.URL.PEOPLE.SELF;
    return http
      .get(
        `${url}?limit=${this.apiConfig.Limit}&query=${this.apiConfig.query}&sortDir=${this.apiConfig.sortDir}&page=${this.apiConfig.page}`
      )
      .catch((err: any) => {
        console.error("Error loading payrolls: ", err);
        return Promise.reject(err);
      });
  }
  static getTeamAttendanceByPage() {
    if (Utility.isEmpty(this.apiTeamConfig)) {
      this.apiTeamConfig = { ...defaultTeamConfig };
    }
    const url = ApiConstants.URL.PEOPLE.ATTENDANCE;
    return http
      .get(
        `${url}?limit=${this.apiTeamConfig.Limit}&query=${this.apiTeamConfig.query}&sortDir=${this.apiTeamConfig.sortDir}&filter=${this.apiTeamConfig.filter}&page=${this.apiTeamConfig.page}&sort=${this.apiTeamConfig.sort}&searchField=${this.apiTeamConfig.searchField}&searchString=${this.apiTeamConfig.searchString}&userType=${this.apiTeamConfig.userType}&search=${this.apiTeamConfig.search}${!Utility.isEmpty(this.apiTeamConfig.status) ? "&status="+this.apiTeamConfig.status:""}`
      )
      .catch((err: any) => {
        console.error("Error loading payrolls: ", err);
        return Promise.reject(err);
      });
  }
  static getTeamAttendanceDashboard() {
    
    if (Utility.isEmpty(AttendanceService.apiDashboardTeamConfig)) {
      AttendanceService.apiDashboardTeamConfig = { ...defaultDashboardTeamConfig };
    }
    if (AttendanceService.apiDashboardTeamConfig["filter"]) {
      const config = {
        ...AttendanceService.apiDashboardTeamConfig,
        searchString: "",
        searchField: "",
      };
      this.apiDashboardTeamConfig = config;
    }
    const url = ApiConstants.URL.PEOPLE.ATTENDANCE_FILTERED;
    return http
      .get(
        `${url}`,{params:this.apiDashboardTeamConfig}
      )
      .catch((err: any) => {
        console.error("Error loading payrolls: ", err);
        return Promise.reject(err);
      });
  }
  static getDesignation() {
    const url = ApiConstants.URL.PEOPLE.DESIGNATION;
    return http.get(`${url}`).catch((err: any) => {
      console.error("Error loading payrolls: ", err);
      return Promise.reject(err);
    });
  }

    static exportAttendanceReport(params) {
        return axios.create().request({
            withCredentials: true,
            baseURL: ApiConstants.URL.BASE,
            method: "POST",
            url: ApiConstants.URL.PEOPLE.ATTENDANCE_PUNCHLOG_EXPORT,
            responseType: "blob",
            data:params
        });
    }

    static syncBiometricAttendance(attendanceDate) {
        const URL = ApiConstants.URL.BIOMETRIC_ATTENDANCE.SYNC_BIOMETRIC_ATTENDANCE;
        const params = {
            attendanceDate: attendanceDate
        };

        return http.get(URL, { params: params }).catch((err: any) => {
            console.error("Error syncing biometric attendance: ", err);
            return Promise.reject(err);
        });
    }
}

export default AttendanceService;
